import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { validateEmail } from '../../../../../../utils/validation.utils';
import {
    ORFButton
    , ORFDatePicker
    , OR_RRF_TextArea as TextArea
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_InputField as InputField
} from '../../../../../common/forms/order-request-form.component';
import { Row, Col } from 'react-bootstrap';
import { wirelineTerminateCircuitActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate-circuit.reducer";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../../common/file-attachment/file-attachment.component';
import Icons from '../../../../../icon';

class WirelineTerminateExhibitA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            terminateDate: '',
            localToggle: false,
            alterToggle: false,
        }
    }

    componentWillUnmount() {
        this.props.resetFileAttachment();
        this.props.resetRequestData();
        this.props.resetFileAttachment();
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems, uploadFile, saveOrderFile } = this.props;

        var success = await submitRequest(this.state.terminateDate);
        if (success.Success) {
            var res = await uploadFile(success.OrderId);
            if (res != null && res.Result) {
                saveOrderFile(success.OrderId, res.FileNames);
            }

            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    setTerminateDate = (v) => {
        this.setState({
            terminateDate: v
        });
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {

        const {
            //form
            wirelineTerminateCircuitFormA
            //reducer action
            , onSubscriptionSelect
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue
        } = this.props;

        const { subscriptionList, employeeList, takeActionCircuitCode } = this.props.createRequest;
        const { formSubmitted, subscription } = this.props.wirelineTerminateCircuitRequest;
        const { terminateDate } = this.state;

        return (
            <div className="wireline-terminate-container">
                <Form method="post" role="form"
                    model="wirelineTerminateCircuitFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineTerminateCircuitFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')} *`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                defaultValue={takeActionCircuitCode}
                            />
                            {wirelineTerminateCircuitFormA.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                    {subscription.PlanName} <span>&#8226;</span> {subscription.VendorName} <span>&#8226;</span> {subscription.SimName}
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <ORFDatePicker 
                                label={`${this.toLocaleLanguage('terminate_date')} *`}
                                value={terminateDate}
                                action={this.setTerminateDate}
                                disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                                minDate={new Date()}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineTerminateCircuitFormA.employeeEmail}
                                label={`${this.toLocaleLanguage('approver')} *`}
                                propDisplay={'Name'}
                                options={employeeList.length > 0 ? employeeList : ''}
                                onChangeAction={onEmployeeSelect}
                                searchAction={fetchEmployeeByValue}
                                disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <div className="local-contact-container" onClick={this.toggleLocalContainer.bind(this)}>
                        <Icons
                            customClassName="icon-circle-plus"
                            name={this.state.localToggle ? `circle-minus-reg` : `circle-plus-reg`}
                            size="20px"
                            containerClass="icon-circle-plus-container"
                        />
                        <h1 className="local-contact-header"><Translation translationKey="local_contact_title" /></h1>
                    </div>
                    {this.state.localToggle ?
                        <div className="local-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_email_address')} *`}
                                        value={wirelineTerminateCircuitFormA.localContactEmail}
                                        fieldProp='.localContactEmail'
                                        disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_fullname')} *`}
                                        value={wirelineTerminateCircuitFormA.localContactFullName}
                                        fieldProp='.localContactFullName'
                                        disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_phone_number')} *`}
                                        value={wirelineTerminateCircuitFormA.localContactPhone}
                                        fieldProp='.localContactPhone'
                                        disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>
                        : ""}
                    <div className="local-contact-container" onClick={this.toggleAlterContainer.bind(this)}>
                        <Icons
                            customClassName="icon-circle-plus"
                            name={this.state.alterToggle ? `circle-minus-reg` : `circle-plus-reg`}
                            size="20px"
                            containerClass="icon-circle-plus-container"
                        />
                        <h1 className="local-contact-header"><Translation translationKey="alt_local_contact_title" /></h1>
                    </div>
                    {this.state.alterToggle ?
                        <div className="alter-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_email_address')} *`}
                                        value={wirelineTerminateCircuitFormA.altLocalContactEmail}
                                        fieldProp='.altLocalContactEmail'
                                        disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_full_name')} *`}
                                        value={wirelineTerminateCircuitFormA.altLocalContactFullName}
                                        fieldProp='.altLocalContactFullName'
                                        disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_phone_number')} *`}
                                        value={wirelineTerminateCircuitFormA.altLocalContactPhone}
                                        fieldProp='.altLocalContactPhone'
                                        disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>

                        : ""}
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')} *`}
                                fieldProp='.businessJustification'
                                value={wirelineTerminateCircuitFormA.businessJustification}
                                disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelineTerminateCircuitFormA.additionalInformation}
                                disabled={wirelineTerminateCircuitFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <FileAttachment />
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={wirelineTerminateCircuitFormA.circuitId == 0
                                        || wirelineTerminateCircuitFormA.wireLineApproverId == 0

                                        || !validateEmail(wirelineTerminateCircuitFormA.localContactEmail)
                                        || wirelineTerminateCircuitFormA.localContactFullName == ''
                                        || wirelineTerminateCircuitFormA.localContactPhone == ''

                                        || !validateEmail(wirelineTerminateCircuitFormA.altLocalContactEmail)
                                        || wirelineTerminateCircuitFormA.altLocalContactFullName == ''
                                        || wirelineTerminateCircuitFormA.altLocalContactPhone == ''

                                        || terminateDate == ''
                                        || wirelineTerminateCircuitFormA.businessJustification == ''
                                        || formSubmitted}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelineTerminateCircuitRequest, createRequest, translation } = state;
        const { wirelineTerminateCircuitFormA } = state.form;
        return {
            wirelineTerminateCircuitRequest
            , wirelineTerminateCircuitFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelineTerminateCircuitActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
            ),
            dispatch
        )
)(WirelineTerminateExhibitA);